exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-content{border:none;padding:0;position:relative;max-width:800px;width:100%;max-height:90vh;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Layout/SupportModal.scss
// module id = 1095
// module chunks = 74